<template>
  <div v-loading.fullscreen="loading">
    <div class="header-scroll">
      <div class="header">
      <el-button
          v-if="$store.state.role === 'admin'"
          size="default"
          type="primary"
          @click="sendSms"
      >
        SMS yuborish
      </el-button>
      <el-button
          v-if="$store.state.role === 'admin'"
          size="default"
          type="primary"
          @click="openVoteCheckDialog"
      >
        Raqamni tekshirish
      </el-button>
      <el-button
          v-if="$store.state.role !== 'my_garden_moderator'"
          type="primary"
          @click="downloadFile"
          style="margin-right: 5px"
      ><img
          src="@/assets/images/icons/download.svg"
          alt=""
          style="margin-right: 5px"
      />
        Excel
      </el-button>
      <div style="display: flex">
        <el-button
            type="success"
            v-if="
            $store.state.role === 'moderator' || $store.state.role === 'admin'
          "
            style="width: 250px; margin-right: 5px"
            @click="toggleInitiativeFileManage"
        >
          Хужжатларни юклаш
        </el-button>
        <el-select
            v-model="selectedBoardId"
            style="margin-right: 10px; min-width: 180px"
            @change="onChangeBoard"
        >
          <el-option
              v-for="board in boards"
              :key="board.id"
              :value="board.id"
              :label="
              board.title +
              ' ' +
              board.season +
              '-' +
              'mavsum ' +
              board.year +
              ' yil'
            "
          />
        </el-select>
        <el-select
            v-model="selectedPartnership"
            style="margin-right: 10px; min-width: 180px"
            @change="onChangePartnership"
        >
          <el-option
              v-for="option in partnershipOptions"
              :key="option.title"
              :value="getPartnershipOptionValue(option)"
              :label="option.title"
          />
        </el-select>
        <el-input
            v-model="search"
            style="min-width: 150px; margin-right: 10px"
            placeholder="Izlash"
            clearable
            @clear="onSearch"
        >
          <template #append>
            <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt=""/>
            </el-button>
          </template>
        </el-input>
        <el-select
            v-model="stage"
            style="margin-right: 10px; min-width: 150px"
            @change="onChangeStage"
        >
          <el-option key="1" value="" label="Barchasi"/>
          <el-option key="2" value="INITIAL" label="Yangilar"/>
          <el-option key="3" value="PASSED" label="Qabul qilinganlar"/>
          <el-option key="4" value="NOT_PASSED" label="Rad etilganlar"/>
          <el-option key="5" value="WINNER" label="Goliblar"/>
        </el-select>
        <el-select
            v-model="moderation_sub_stage"
            style="margin-right: 10px; min-width: 150px"
            placeholder="Moderatsiya statusi"
            @change="onChangeSubStage"
        >
          <el-option key="1" value="" label="Barchasi"/>
          <el-option
              v-if="
              $store.state.role === 'district_manager' ||
              $store.state.role === 'admin'
            "
              key="2"
              value="MODERATOR_ACCEPTED"
              label="Moderator qabul qilgan"
          />
          <el-option
              v-if="
              $store.state.role === 'district_manager' ||
              $store.state.role === 'admin'
            "
              key="3"
              value="MODERATOR_DENIED"
              label="Moderator rad etgan"
          />
          <el-option
              v-if="
              $store.state.role === 'moderator' || $store.state.role === 'admin'
            "
              key="4"
              value="DISTRICT_MANAGER_ACCEPTED"
              label="Tuman mudiri qabul qilgan"
          />
          <el-option
              v-if="
              $store.state.role === 'moderator' || $store.state.role === 'admin'
            "
              key="5"
              value="DISTRICT_MANAGER_DENIED"
              label="Tuman mudiri rad etgan"
          />
        </el-select>
        <el-button
            v-if="
            (stage === 'WINNER' ||
              stage === 'PASSED' ||
              stage === 'PUBLIC_CONTROL') &&
            initiatives?.length &&
            $store.state.role === 'admin'
          "
            size="default"
            type="primary"
            @click="downloadVotes"
        >
          Ovozlarni yuklash
        </el-button>
        <!-- <el-radio-group v-model="stage" @change="onChangeStage">
          <el-radio-button label="INITIAL">Yangilar</el-radio-button>
          <el-radio-button label="PASSED">Qabul qilinganlar</el-radio-button>
          <el-radio-button label="NOT_PASSED">Rad etilganlar</el-radio-button>
          <el-radio-button label="WINNER">Goliblar</el-radio-button>
        </el-radio-group> -->
      </div>
      </div>
    </div>
    <template
        v-if="
        showInitiativeFileManage &&
        ($store.state.role === 'moderator' || $store.state.role === 'admin')
      "
    >
      <InitiativeFileManage
          :close="toggleInitiativeFileManage"
          :board_id="selectedBoardId"
          @protocolFileUploaded="protocolUpload = false"
      />
    </template>
    <el-table
        :data="initiatives"
        class="table"
        border
        height="calc(100vh - 250px)"
    >
      <el-table-column type="expand">
        <template #default="scope">
          <div>
            <h2 class="field-title desc-item">{{ scope.row.title }}</h2>
            <div class="desc-item">
              <span class="field-title">Tashabbuskor:</span>
              {{ scope.row.author_fullname }}
            </div>
            <div class="desc-item">
              <span class="field-title">Tashabbus tavsifi:</span>
              {{ scope.row.description }}
            </div>
            <div class="desc-item">
              <span class="field-title">Manzil:</span>
              {{
                `${scope.row.region_title}, ${scope.row.district_title}, ${scope.row.quarter_title}`
              }}
              <el-button
                  size="small"
                  @click="
                  showOnMap(
                    scope.row.latitude,
                    scope.row.longitude,
                    scope.row.title?.length
                      ? scope.row.title
                      : scope.row.description
                  )
                "
              >
                <img
                    src="@/assets/images/sidebar/location.svg"
                    alt=""
                    height="19"
                    style="margin-right: 5px"
                />
                Xaritada ko'rsatish
              </el-button>
            </div>
            <div class="desc-item">
              <div class="field-title" style="margin-bottom: 7px">
                Fotosuratlar:
              </div>
              <div class="image-list">
                <el-image
                    v-for="(imageUrl, index) in scope.row.images"
                    :key="index"
                    style="width: 100px; height: 100px"
                    :src="`${BASE_IMAGE_URL}${imageUrl}`"
                    :zoom-rate="1.2"
                    :preview-src-list="generateSrcList(scope.row.images)"
                    :initial-index="index"
                    fit="cover"
                />
              </div>
            </div>

            <div
                class="desc-item"
                style="display: flex; align-items: center;"
                v-if="scope.row.ai_moderation_overall && scope.row.ai_moderation_overall !== 'FAILED'"
            >
              <div class="field-title" style="margin-right: 10px;">AI tavsiyasi:</div>
              <el-button
                  size="small"
                  :type="getAiModerationBtnType(scope.row.ai_moderation_overall)"
                  @click="openAiModerationModal(scope.row)"
              >
                <span style="margin-right: 5px">{{ getAiModerationIcon(scope.row.ai_moderation_overall) }}</span>
                AI tahlili
              </el-button>
            </div>

            <div
                class="desc-item"
                style="display: flex"
                v-if="$store.state.role === 'my_garden_moderator'"
            >
              <el-button
                  v-if="scope.row.stage === 'INITIAL'"
                  size="default"
                  type="danger"
                  @click="
                  declineInitiative(
                    scope?.row?.id,
                    scope?.row?.title?.length
                      ? scope?.row?.title
                      : scope?.row?.description
                  )
                "
              >
                Rad etish
              </el-button>
              <el-button
                  v-if="scope.row.stage === 'INITIAL'"
                  size="default"
                  type="primary"
                  @click="acceptInitiative(scope?.row)"
              >
                Tasdiqlash
              </el-button>
            </div>
            <div
                class="desc-item"
                style="display: flex"
                v-if="$store.state.role === 'moderator'"
            >
              <div
                  style="margin-right: 10px; display: flex; align-items: center; gap: 8px;"
                  v-if="
                  scope.row.stage === 'INITIAL' &&
                  (scope.row.moderation_sub_stage ===
                    'DISTRICT_MANAGER_DENIED' ||
                    scope.row.moderation_sub_stage === null)
                "
              >
                <el-tag
                    v-if="scope.row.ai_moderation_status"
                    size="small"
                    :type="getAiModerationStatusTagType(scope.row.ai_moderation_status)"
                >
                  {{ getAiModerationStatusLabel(scope.row.ai_moderation_status) }}
                </el-tag>
                <el-button
                    v-if="scope?.row?.stage === 'INITIAL'"
                     :disabled="
                  boards.find((board) => board.id === selectedBoardId).stage !== 'REVIEW' &&
                  boards.find((board) => board.id === selectedBoardId).stage !== 'PROMOTION'
                "
                    size="default"
                    type="primary"
                    @click="
                    bringToModiration(
                      scope.row
                    )
                  "
                >
                  Moderatsiyadan o'tkazish
                </el-button>
              </div>
              <el-button
                  size="default"
                  type="primary"
                  @click="
                  $router.push({
                    name: 'ChronologyList',
                    params: { initiativeId: scope.row.id },
                    query: { board_id: selectedBoardId },
                  })
                "
              >
                Tashabbus xronologiyasi
              </el-button>

              <!-- Muddat tugaganda faqat "berish" yo'nalishi yopiladi, huquqni
                   qaytarib olish har doim ochiq qoladi. -->
              <el-button
                  :type="scope.row.is_editable ? 'danger' : 'warning'"
                  @click="onClickAuthorEdit(scope.row.id, !scope.row.is_editable)"
                  v-if="
                  authorEditControlVisible(scope.row) &&
                  (scope.row.is_editable || canGrantEditPermission)
                "
              >
                {{
                  scope.row.is_editable
                      ? "Muallifdan tahrirlash huquqini olish"
                      : "Muallifga tahrirlash huquqini berish"
                }}
              </el-button>
              <el-tooltip
                  v-else-if="authorEditControlVisible(scope.row)"
                  placement="top"
                  :content="editPermissionExpiredHint"
              >
                <span class="edit-permission-locked">
                  <el-button size="default" type="info" plain disabled>
                    <el-icon class="el-icon--left">
                      <Lock/>
                    </el-icon>
                    Tahrirlash huquqi: muddat tugagan
                  </el-button>
                </span>
              </el-tooltip>
              <el-button
                  size="default"
                  type="primary"
                  v-if="
                  boards.find((board) => board.id === selectedBoardId).stage === 'REVIEW' ||
                  boards.find((board) => board.id === selectedBoardId).stage === 'PROMOTION'
                "
                  @click="
                  $router.push({
                    name: 'InitiativeEdit',
                    params: { id: scope.row.id },
                    query: { isModerator: true },
                  })
                "
              >
                Tashabbusni tahrirlash
              </el-button>
              <el-button
                  v-if="
                      scope.row.stage === 'WINNER' &&
                      (scope.row.board_year >= 2023 || scope.row.board_year === 0)
                      && $store.state.role === 'moderator'
                    "
                  size="default"
                  type="primary"
                  @click="onClickShaffofQurilish(scope.row)"
              >
                Shaffof qurilish
              </el-button>
            </div>
            <div class="desc-item" v-if="$store.state.role === 'admin'">
              <el-button
                  v-if="scope.row.stage !== 'INITIAL'"
                  size="default"
                  type="primary"
                  @click="returnInitiative(scope.row.public_id)"
              >
                1-bosqichga qaytarish
              </el-button>
              <el-button
                  size="default"
                  type="primary"
                  @click="
                  $router.push({
                    name: 'InitiativeEdit',
                    params: { id: scope.row.id },
                  })
                "
              >
                Tashabbusni tahrirlash
              </el-button>
              <reestr-edit-form
                  v-if="scope.row.type === 'EQUIPMENT'"
                  :initiative="scope.row.id"
                  :initiative-category-id="scope.row.category_id"
              />
              <el-button
                  v-if="
                  scope.row.stage === 'WINNER' &&
                  (scope.row.board_year >= 2023 || scope.row.board_year === 0)
                "
                  size="default"
                  type="primary"
                  @click="
                  $router.push({
                    name: 'ChronologyMain',
                    params: {
                      public_id: scope.row.public_id,
                    },
                    query: {
                      id: scope.row.id,
                      board_id: scope.row.board_id,
                      region_id: scope.row.region_id,
                      district_id: scope.row.district_id,
                      council_decision_id: scope.row.council_decision_id,
                      granted_amount: scope.row.granted_amount,
                      desc:scope.row.type==='CONSTRUCTION'?scope.row.description.slice(0,255):scope.row?.organization_title+' (Жиҳозлаш)',
                      type:scope.row.type,
                      soato:scope.row.district_soato,
                      tin:scope.row.customer_tin,
                      category:scope.row.category_id,
                      board_type: scope.row.board_type,
                    }
                  })
                "
              >
                Shaffof Invest Data
              </el-button>
              <el-button
                  v-if="scope.row.stage === 'WINNER'"
                  size="default"
                  type="primary"
                  @click="investIdDialog(scope.row.public_id)"
              >
                Invest Id biriktirish
              </el-button>
              <el-upload
                  v-if="
                  scope.row.stage === 'WINNER' ||
                  scope.row.stage === 'PASSED' ||
                  scope.row.stage === 'PUBLIC_CONTROL'
                "
                  ref="uploadRef"
                  class="upload-demo"
                  style="margin-top: 10px"
                  :auto-upload="false"
                  :multiple="false"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  v-model:file-list="file"
                  :limit="1"
                  @change="onChangeReestrFile"
                  :on-exceed="onExceed"
                  :on-error="onErrorUpload"
              >
                <template #trigger>
                  <el-button
                      @click="onClickReestrUploadButton(scope.row.id)"
                      type="primary"
                  >Restr faylini yuklash
                  </el-button>
                </template>
              </el-upload>

              <el-button
                  v-if="scope.row.stage !== 'WINNER'"
                  size="default"
                  type="primary"
                  @click="promoteToWinner(scope.row.public_id)"
              >
                Golib deb tayinlash
              </el-button>
              <el-button
                  v-if="scope.row.stage === 'WINNER'"
                  size="default"
                  type="danger"
                  @click="returnToPassedStage(scope.row.public_id)"
              >
                Goliblikdan mahrum etish
              </el-button>
              <el-button
                  v-if="scope.row.stage === 'WINNER'"
                  size="default"
                  type="danger"
                  @click="toggleIgnoreInitiativeDialog(scope.row.public_id)"
              >
                Tashabbusni man etish
              </el-button>
              <el-button
                  v-if="scope.row.stage === 'WINNER'"
                  size="default"
                  type="danger"
                  @click="updateAktFile(scope.row.public_id)"
              >
                AKT fileni yangilash
              </el-button>
              <!-- ai-moderation -->
               <el-button
                    v-if="scope?.row?.stage === 'INITIAL'"
                    size="default"
                    type="primary"
                    :disabled="
                  boards.find((board) => board.id === selectedBoardId).stage !== 'REVIEW' &&
                  boards.find((board) => board.id === selectedBoardId).stage !== 'PROMOTION'
                "
                    @click="
                    bringToModiration(
                      scope.row
                    )
                  "
                >
                  Moderatsiyadan o'tkazish
                </el-button>
            </div>
            <div
                class="desc-item"
                v-if="$store.state.role === 'district_manager'"
            >
              <div
                  v-if="
                  scope.row.stage === 'INITIAL' &&
                  (scope.row.moderation_sub_stage === 'MODERATOR_ACCEPTED' ||
                    scope.row.moderation_sub_stage === 'MODERATOR_DENIED')
                "
              >
                <el-button
                    size="default"
                    type="primary"
                    @click="acceptInitiativeDistrictManager(scope.row.id)"
                >
                  Tasdiqlash
                </el-button>
                <el-button
                    size="default"
                    type="danger"
                    @click="acceptDistrictManager(scope.row.id, 'deny')"
                >
                  Rad etish
                </el-button>
              </div>
            </div>
            <div
                class="desc-item"
                v-if="
                $store.state.role === 'admin' ||
                $store.state.role === 'moderator'
              "
            >
              <el-button
                  size="default"
                  v-if="scope.row.longitude === 0"
                  type="warning"
                  @click="
                  changeLocation(
                    scope.row.id,
                    scope.row.latitude,
                    scope.row.longitude,
                    scope.row.address_title
                      ? scope.row.address_title
                      : 'Манзилни танланг'
                  )
                "
              >
                <img
                    src="@/assets/images/sidebar/location.svg"
                    alt=""
                    height="19"
                    style="margin-right: 5px"
                />
                Manzil biriktirish
              </el-button>
              <el-button
                  v-else
                  size="default"
                  type="warning"
                  :disabled="$store.state.role === 'moderator'"
                  @click="permissionSetLocation(scope.row.id)"
              >
                {{ $store.state.role === 'moderator' ? 'Manzil biriktirilgan' : 'Manzil biriktirish ruxsatini berish' }}
              </el-button>
              <el-button
                  v-if="scope.row.stage === 'WINNER'"
                  size="default"
                  type="warning"
                  @click="addMobileMonitoring(scope.row.id)"
              >
                Sayyor monitoring
              </el-button>
            </div>

            <!-- Tranzit hisob raqam-->
            <div
                class="desc-item"
                v-if="
                  $store.state.role === 'admin' &&
                  scope.row.is_partnership &&
                  scope.row.stage === 'PASSED' &&
                  (boards.find((board) => board.id === selectedBoardId).stage === 'REVIEW' || boards.find((board) => board.id === selectedBoardId).stage === 'PROMOTION')
                "
            >
              <el-button
                  v-if="!scope.row.transit_account_number"
                  size="default"
                  type="primary"
                  @click="showTransitDialog(scope.row.id, '')"
              >
                Tranzit hisob raqam biriktirish
              </el-button>
              <el-button
                  v-else
                  size="default"
                  type="warning"
                  @click="showTransitDialog(scope.row.id, scope.row.transit_account_number)"
              >
                Tranzit hisob raqamni o'zgartirish
              </el-button>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column type="index" :index="indexMethod" width="80"/>
      <el-table-column prop="public_id" width="140" label="ID"/>
      <el-table-column prop="region_title" label="Viloyat" width="180"/>
      <el-table-column prop="district_title" label="Tuman" width="180"/>
      <el-table-column prop="quarter_title" label="Mahalla" width="180"/>
      <el-table-column
          prop="author_fullname"
          label="Tashabbus muallifi"
          width="180"
      />
      <el-table-column prop="title" label="Tashabbus mavzusi" min-width="200">
        <template #default="scope">
          <div class="initiative-title">
            {{
              scope.row.title?.length ? scope.row.title : scope.row.description
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan sana" width="150">
        <template #default="scope">
          {{ new Date(scope.row.created_at).toLocaleDateString("ru-RU") }}
        </template>
      </el-table-column>
      <el-table-column prop="stage" label="Bosqich" width="150">
        <template #default="scope">
          <el-tag :type="stages[scope.row.stage].type">
            {{ stages[scope.row.stage].text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
          prop="requested_amount"
          label="Ma'qullangan mablag'"
          width="170"
      >
        <template #default="scope">
          {{ scope.row.granted_amount.toLocaleString("ru-RU") }} so'm
        </template>
      </el-table-column>
      <el-table-column
          prop="requested_amount"
          label="So'ralgan mablag'"
          width="170"
      >
        <template #default="scope">
          {{ scope.row.requested_amount.toLocaleString("ru-RU") }} so'm
        </template>
      </el-table-column>
      <el-table-column
          prop="transit_account_number"
          label="Tranzit hisob raqam"
          width="250"
      >
        <template v-slot="scope">
          {{ scope.row.transit_account_number ? scope.row.transit_account_number : '-' }}
        </template>
      </el-table-column>
      <el-table-column
          prop="transit_account_balance"
          label="Tranzit mablag'"
          width="180"
      >
        <template v-slot="scope">
          {{ scope.row.transit_account_balance.toLocaleString("ru-RU") }} so'm
        </template>
      </el-table-column>
      <el-table-column
          prop="moderation_sub_stage"
          label="Moderatsiya holati"
          width="180"
      >
        <template v-slot="scope">
          {{ moderationStageStatus[scope.row.moderation_sub_stage] }}
        </template>
      </el-table-column>
      <el-table-column
          prop="moderation_sub_stage_comment"
          label="Moderatsiya izohi"
          width="180"
      />
    </el-table>
    <div class="pagination">
      <div>Tashabbuslar soni: {{ totalCount }}</div>
      <el-pagination
          background
          layout="sizes, prev, pager, next"
          :total="totalCount"
          v-model:page-size="limit"
          v-model:current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
      />
    </div>

    <el-dialog v-model="showMapDialog" :title="dialogTitle">
      <InitiativeYandexMap :lat-long="latLong"/>
    </el-dialog>

    <el-dialog
        style="width: 70%"
        v-model="locationDialogVisible"
        align-center
        :title="
        locationForm.address_title
          ? locationForm.address_title
          : locationDialogTitle
      "
    >
      <yandex-map
          style="width: 100%; height: 80vh"
          :coords="[locationForm.latitude, locationForm.longitude]"
          :zoom="10"
          :settings="settings"
          :controls="['fullscreenControl', 'zoomControl', 'typeSelector']"
          @click="onClickMap"
      >
        <ymap-marker
            :coords="[locationForm.latitude, locationForm.longitude]"
            marker-id="marker"
        />
      </yandex-map>
      <template #footer>
        <el-button type="primary" @click="onClickSubmit">Tanlash</el-button>
      </template>
    </el-dialog>
    <!-- ignore initiative form -->
    <el-dialog
        v-model="dialogIgnoreInitiative"
        destroy-on-close
        title="Tashabbusni man etish boyicha"
    >
      <el-form :model="ignoreForm" ref="ignoreForm" :rules="ignorRules">
        <el-form-item label="Fayl" prop="file_id">
          <el-upload
              accept="application/pdf"
              v-model:file-list="ignoredInitiativeFiles"
              :action="fileUploadUrl"
              :headers="fileUploadHeader"
              :multiple="false"
              :limit="1"
              :on-success="onSuccessFileUpload_IgnoreInitiative"
              :on-remove="handleRemoveFile_IgnoreInitiative"
          >
            <el-button
                type="primary"
                :disabled="ignoredInitiativeFiles.length > 0"
            >Fayl yuklang
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="Izohni kiriting" prop="comment">
          <el-input type="textarea" v-model="ignoreForm.comment"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeIgnoreInitiative">Cancel</el-button>
          <el-button type="primary" @click="completeIgnoreInitiative">
            Confirm
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!--    decline dialog-->
    <el-dialog
        v-model="declineDialog"
        title="Tashabbusni rad etish"
        @close="closeDecline"
        style="max-width: 600px"
        align-center
    >
      <el-form
          ref="declineForm"
          :model="declineForm"
          :rules="rules"
          label-position="top"
          style="width: 500px"
          status-icon
          hide-required-asterisk
      >
        <el-form-item label="Rad etish sababi" prop="cancelation_reason_id">
          <el-select
              v-model="declineForm.cancelation_reason_id"
              style="width: 100%"
          >
            <el-option
                v-for="reason in cancelingReasons"
                :key="reason.id"
                :value="reason.id"
                :label="reason.title"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Kommentariya" prop="moderator_comment">
          <el-input v-model="declineForm.moderator_comment" type="textarea"/>
        </el-form-item>
        <el-form-item label="Fayl" prop="file_id" v-if="showFileUpload">
          <el-upload
              accept="application/pdf"
              v-model:file-list="declineFiles"
              :action="fileUploadUrl"
              :headers="fileUploadHeader"
              :multiple="false"
              :limit="1"
              :on-success="onSuccessFileUpload"
              :on-remove="handleRemoveFile"
          >
            <el-button type="primary" :disabled="declineFiles.length > 0"
            >Fayl yuklang
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeDecline">Bekor qilish</el-button>
          <el-button type="primary" @click="completeDecline">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!--    invest id dialog-->
    <el-dialog
        v-model="investId"
        title="Invest Id biriktirish"
        @close="closeInvestId"
        style="max-width: 600px"
        align-center
    >
      <el-form
          ref="declineForm"
          :model="declineForm"
          :rules="rules"
          label-position="top"
          style="width: 500px"
          status-icon
          hide-required-asterisk
      >
        <el-form-item label="Invest Id" prop="invest_object_id">
          <el-input v-model="invest_object_id" type="number"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="completeInvestId">
            Yuborish
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!--    send sms dialog-->
    <el-dialog
        v-model="showSendSmsDialog"
        width="40%"
        title="Jamoatchilik nazoratidan o'tmagan loyihalarga sms yuborish"
    >
      <h3 style="margin-bottom: 5px"><strong>Boardni tanlang</strong></h3>
      <el-select
          style="width: 100%"
          size="large"
          v-model="selectedBoardIdForSms"
      >
        <el-option
            v-for="board in boards"
            :key="board.id"
            :value="board.id"
            :label="
            board.title +
            ' ' +
            board.season +
            '-' +
            'mavsum ' +
            board.year +
            ' yil'
          "
        />
      </el-select>
      <div style="margin-top: 15px">
        <el-button @click="onClickCancel">Bekor qilish</el-button>
        <el-button type="primary" @click="onClickSendSms">Yuborish</el-button>
      </div>
    </el-dialog>
    <el-dialog
        v-model="voteCheckDialogVisible"
        width="40%"
        title="Raqamni tekshirish"
        @close="closeVoteCheckDialog"
    >
      <el-form
          ref="voteCheckFormRef"
          :model="voteCheckForm"
          :rules="voteCheckRules"
          label-position="top"
      >
        <el-form-item label="Boardni tanlang" prop="board_id">
          <el-select
              v-model="voteCheckForm.board_id"
              style="width: 100%"
          >
            <el-option
                v-for="board in boards"
                :key="board.id"
                :value="board.id"
                :label="
                board.title +
                ' ' +
                board.season +
                '-' +
                'mavsum ' +
                board.year +
                ' yil'
              "
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Telefon raqam" prop="phone_number">
          <el-input
              v-model="voteCheckForm.phone_number"
              placeholder="90 123 45 67"
              maxlength="13"
              @input="onVoteCheckPhoneInput"
              @keyup.enter="checkPhoneVote"
          >
            <template #prepend>+998</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div v-if="voteCheckResultStatus === 'empty'" class="vote-check-alert success">
        <div class="vote-check-title success-text">
          {{ voteCheckEmptyMessage }}
        </div>
      </div>
      <div v-else-if="voteCheckResultStatus === 'found'" class="vote-check-alert warning">
        <div class="vote-check-title warning-text">
          Ushbu raqam egasi joriy mavsumda ovoz bergan
        </div>
        <div>
          Ovoz berilgan telefon raqam:
          <strong>{{ formatVoteCheckResultPhone(voteCheckResult.phone_number) }}</strong>
        </div>
        <div>
          Ovoz berilgan qurilma:
          <strong>{{ voteCheckResult.device_type }}</strong>
        </div>
        <div>
          Ovoz berilgan vaqt:
          <strong>{{ formatVoteCheckDate(voteCheckResult.created_at) }}</strong>
        </div>
        <div>
          Ovoz berilgan tashabbus: 
          <a
              :href="voteCheckResult.initiative_link"
              target="_blank"
              rel="noopener noreferrer"
          >
            <strong>{{ voteCheckResult.initiative_link }}</strong>
          </a>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeVoteCheckDialog">Bekor qilish</el-button>
          <el-button
              type="primary"
              :loading="voteCheckSubmitting"
              @click="checkPhoneVote"
          >
            Tekshirish
          </el-button>
        </span>
      </template>
    </el-dialog>
    <!--    Moderator and District_manager accept and deny dialog-->
    <el-dialog
        v-model="acceptDenyDialogVisible"
        :title="`Tashabbusni ${
        acceptDenyUrlKey === 'accept' ? 'tasdiqlash' : 'rad etish'
      }`"
        style="max-width: 600px"
        align-center
    >
      <el-input type="textarea" rows="10" v-model="acceptDenyComment"/>

      <div style="margin-top: 10px; text-align: right">
        <el-button type="info" @click="acceptDenyCancel"
        >Bekor qilish
        </el-button
        >
        <el-button type="primary" @click="denySave">Saqlash</el-button>
      </div>
    </el-dialog>
    <el-dialog
        align-center
        width="35%"
        v-model="mobileMonitoringDialog"
        title="O'zingiz uchun kerakli dasturni tanlang"
    >
      <div class="applications">
        <a
            style="margin-right: 20px"
            href="https://play.google.com/store/apps/details?id=uz.minfin.open_budget"
            target="_blank"
        >
          <google-play-icon/>
        </a>
        <a
            href="https://apps.apple.com/uz/app/open-budget-uz/id6447674229"
            target="_blank"
        >
          <app-store-icon/>
        </a>
      </div>
    </el-dialog>
    <!--    Transit account number biriktirish-->
    <el-dialog
        v-model="isShowTransit"
        title="Transit hisob raqam biriktirish"
        @close="closeTransitDialog"
        style="max-width: 600px"
        align-center
    >
      <el-form
          ref="transitForm"
          :rules="transitRules"
          :model="transitForm"
          label-position="top"
          style="width: 500px"
          status-icon
          hide-required-asterisk
      >
        <el-form-item label="Tranzit hisob raqam" prop="transit_account_number">
          <el-input v-model="transitForm.transit_account_number" type="number"/>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="transitNumberCreate()">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!-- AI Moderation Modal -->
    <el-dialog
        v-model="aiModerationDialogVisible"
        title="AI Moderatsiya Tavsiyasi"
        width="600px"
        align-center
    >
      <div v-loading="aiModerationLoading" style="min-height: 100px;">
        <div
            v-if="$store.state.role === 'admin'"
            style="display: flex; justify-content: flex-end; margin-bottom: 15px;"
        >
          <el-button
              size="small"
              type="primary"
              plain
              :loading="aiModerationResending"
              :disabled="isAiModerationResendDisabled"
              @click="resendAiModeration"
          >
            Qayta tekshirish
          </el-button>
        </div>
        <div v-if="aiModerationData" class="ai-moderation-content">
          <!-- Overall verdict -->
          <div
              v-if="aiModerationData.ai_moderation_overall"
              class="ai-overall-banner"
              :class="`ai-overall-banner--${aiModerationData.ai_moderation_overall.toLowerCase()}`"
          >
            <span v-if="aiModerationData.ai_moderation_overall === 'PENDING'" class="ai-pending-spinner"></span>
            <span v-else class="ai-overall-banner-icon">{{ getAiModerationIcon(aiModerationData.ai_moderation_overall) }}</span>
            <span class="ai-overall-banner-text">{{ getAiModerationOverallLabel(aiModerationData.ai_moderation_overall) }}</span>
          </div>

          <template v-if="aiModerationData.ai_moderation_overall !== 'PENDING'">
            <!-- Duplicates Warning -->
            <el-alert
              v-if="aiModerationData.ai_duplicate_status === 'DUPLICATE'"
              type="warning"
              show-icon
              :closable="false"
              style="margin-bottom: 15px;"
            >
              <template #title>
                <span style="font-weight: bold; font-size: 14px;">Duplicate — asl: {{ aiModerationData.ai_duplicate_of_public_id }}</span>
              </template>
              <div style="margin-top: 5px;">
                Ushbu tashabbus avvalroq kiritilgan tashabbus bilan mazmunan bir xil.
                <br/>
                <el-button link type="primary" style="padding: 0; margin-top: 5px;" @click="openDuplicateOriginal(aiModerationData.ai_duplicate_of_public_id)">
                  Asl tashabbusni ochish
                </el-button>
              </div>
            </el-alert>

            <!-- Error message if FAILED -->
            <el-alert
              v-if="aiModerationData.ai_moderation_overall === 'FAILED' && aiModerationData.ai_moderation_error"
              type="error"
              show-icon
              :closable="false"
              title="AI servisiga ulanishda texnik xato"
              style="margin-bottom: 15px;"
            >
              <div style="margin-top: 5px;">Debug: {{ aiModerationData.ai_moderation_error }}</div>
            </el-alert>

            <div v-if="aiModerationData.ai_moderation_result && aiModerationData.ai_moderation_result.length > 0">
              <div v-for="item in sortedAiModerationResult" :key="item.criterion" class="ai-criterion-row">
                <div class="ai-criterion-icon">
                  {{ getVerdictIcon(item.verdict) }}
                </div>
                <div class="ai-criterion-details">
                  <div class="ai-criterion-title">{{ item.title }}</div>
                  <div class="ai-criterion-message">{{ item.message }}</div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <template #footer v-if="aiModerationData?.ai_moderation_overall !== 'PENDING' && aiModerationData?.ai_moderation_result && aiModerationData?.ai_moderation_result?.length > 0">
        <span class="dialog-footer">
          <el-button
              size="default"
              type="danger"
              @click="
              declineInitiative(
                currentAiModerationRow?.id,
                currentAiModerationRow?.title?.length
                  ? currentAiModerationRow?.title
                  : currentAiModerationRow?.description
              )
            "
          >
            Rad etish
          </el-button>
          <el-button
              size="default"
              type="primary"
              @click="acceptInitiative(currentAiModerationRow)"
          >
            Tasdiqlash
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import InitiativeYandexMap from "@/components/map/InitiativeYandexMap.vue";
import InitiativeFileManage from "@/views/initiatives/InitiativeFileManage.vue";
import {ElMessageBox, ElNotification} from "element-plus";
import axios from "axios";
import ReestrEditForm from "@/components/reestr/ReestrEditForm.vue";
import GooglePlayIcon from "@/components/icon/GooglePlayIcon.vue";
import AppStoreIcon from "@/components/icon/AppStoreIcon.vue";
import {Lock} from "@element-plus/icons-vue";

export default {
  name: "InitiativeList",
  components: {
    Lock,
    AppStoreIcon,
    GooglePlayIcon,
    ReestrEditForm,
    InitiativeYandexMap,
    InitiativeFileManage,
  },
  watch: {
    aiModerationDialogVisible(visible) {
      if (!visible) {
        this.clearAiModerationPolling();
      }
    },
  },
  computed: {
    selectedBoard() {
      return this.boards.find((board) => board.id === this.selectedBoardId);
    },
    // Serverda hisoblangan bayroq (board.edit_permission_end_date bo'yicha).
    // Sanani mahalliy soat bilan taqqoslamaymiz. Maydon yo'q bo'lsa (eski
    // backend) — cheklovsiz deb qaraymiz, aks holda tugma yo'qolib qoladi.
    canGrantEditPermission() {
      return this.selectedBoard?.can_grant_edit_permission !== false;
    },
    editPermissionExpiredHint() {
      const deadline = this.selectedBoard?.edit_permission_end_date;
      if (!deadline) {
        return "Muallifga tahrirlash huquqini berish muddati tugagan";
      }
      return `Muallifga tahrirlash huquqini berish muddati ${this.$moment(
          deadline
      ).format("DD.MM.YYYY HH:mm")} da tugagan`;
    },
    sortedAiModerationResult() {
      if (!this.aiModerationData?.ai_moderation_result) return [];
      const order = ['territory', 'collective_benefit', 'personal_or_departmental', 'maintenance_cost', 'state_organ_building'];
      return [...this.aiModerationData.ai_moderation_result].sort((a, b) => {
        return order.indexOf(a.criterion) - order.indexOf(b.criterion);
      });
    },
    isAiModerationResendDisabled() {
      if (!this.aiModerationData || this.aiModerationData.ai_moderation_overall !== 'PENDING') {
        return false;
      }
      if (!this.aiModerationData.ai_moderation_checked_at) {
        return true;
      }
      const checkedAt = new Date(this.aiModerationData.ai_moderation_checked_at).getTime();
      const hoursSinceChecked = (Date.now() - checkedAt) / (1000 * 60 * 60);
      return hoursSinceChecked < 5;
    },
    showFileUpload() {
      return this.cancelingReasons.find(
          (item) => this.declineForm.cancelation_reason_id === item.id
      )?.file_required;
    },
    selectedPartnershipOption() {
      return this.partnershipOptions.find(
          (option) =>
              this.getPartnershipOptionValue(option) === this.selectedPartnership
      );
    },
    partnershipParamsForApi() {
      if (this.selectedPartnership === "all") {
        return {
          is_partnership: null,
          is_deputy_chosen: null,
        };
      }

      return {
        is_partnership:
            this.selectedPartnershipOption?.type === "is_partnership"
                ? this.selectedPartnershipOption.value
                : null,
        is_deputy_chosen:
            this.selectedPartnershipOption?.type === "is_deputy_chosen"
                ? this.selectedPartnershipOption.value
                : null,
      };
    },
    partnershipQueryForRoute() {
      if (this.selectedPartnership === "all") {
        return {
          is_partnership: undefined,
          is_deputy_chosen: undefined,
        };
      }

      return {
        is_partnership:
            this.selectedPartnershipOption?.type === "is_partnership"
                ? this.selectedPartnershipOption.value
                : undefined,
        is_deputy_chosen:
            this.selectedPartnershipOption?.type === "is_deputy_chosen"
                ? this.selectedPartnershipOption.value
                : undefined,
      };
    }
  },
  data() {
    function amountValidate(rule, value, callback) {
      if (value === "0") {
        callback(new Error("Qiymat 0 dan katta bo'lishi kerak"));
      } else if (parseFloat(value.replace(/\s/g, "")) > 1360000000) {
        callback(new Error("Qiymat 1 360 000 000 dan kichick bo'lishi kerak"));
      } else {
        callback();
      }
    }

    function voteCheckPhoneValidate(rule, value, callback) {
      const digits = (value || "").replace(/\D/g, "");

      if (!digits.length) {
        callback(new Error("Majburiy maydon"));
      } else if (digits.length !== 9) {
        callback(new Error("Telefon raqam formati noto'g'ri"));
      } else {
        callback();
      }
    }

    return {
      BASE_IMAGE_URL: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/`,
      fileUploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
      fileUploadHeader: {Authorization: `${this.$store.state.accessToken}`},
      loading: false,
      aiModerationDialogVisible: false,
      aiModerationLoading: false,
      aiModerationResending: false,
      aiModerationData: null,
      currentAiModerationRow: null,
      aiModerationPollTimer: null,
      dialogIgnoreInitiative: false,
      investId: false,
      isShowTransit: false,
      invest_object_id: "",
      transit_account_number: 0,
      initiativeId: "",
      stage: "",
      latLong: [],
      showMapDialog: false,
      dialogTitle: "",
      organizationList: [],
      showOrganizationField: false,

      stages: {
        INITIAL: {text: "Ko'rib chiqish", type: ""},
        NOT_PASSED: {text: "Rad etilgan", type: "danger"},
        PASSED: {text: "Qabul qilingan", type: "success"},
        WINNER: {text: "Goliblar", type: "success"},
      },
      partnershipOptions: [
        { title: 'Barchasi', value: 'all', type: 'is_deputy_chosen' },
        { title: 'Sheriklik loyihalari', value: 'true', type: 'is_partnership' },
        { title: 'Deputat tashabbusi', value: 'true', type: 'is_deputy_chosen' },
      ],
      selectedPartnership: 'all',
      initiatives: [],
      totalCount: 0,
      limit: 20,
      currentPage: 1,
      search: null,

      cancelingReasons: [],
      quarters: [],
      categories: [],
      boards: [],
      tags: [],

      selectedBoardId: null,

      disableButtons: true,

      declineDialog: false,
      acceptDialog: false,
      declineFiles: [],
      declineForm: {
        id: null,
        cancelation_reason_id: null,
        moderator_comment: null,
        file_id: null,
      },
      transitForm: {
        transit_account_number: 0,
      },

      ignoredInitiativeFiles: [],
      ignoreForm: {
        comment: null,
        ignoreInitiativeFileId: null,
      },
      currentPublicId: null,
      moderation_sub_stage: "",

      acceptDenyDialogVisible: false,
      acceptDenyUrlKey: null,
      acceptDenyInitiativeId: null,
      acceptDenyComment: null,

      rules: {
        cancelation_reason_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        moderator_comment: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
        file_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        granted_amount: [{validator: amountValidate, trigger: "blur"}],
        tags: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        organization_id: [
          {
            required: true,
            message: "Majburiy maydon",
            trigger: "change",
          },
        ],
      },
      transitRules: {
        transit_account_number: [
          {
            required: true,
            message: "Majburiy maydon",
            trigger: "change",
          },
          {
            min: 27,
            max: 27,
            message: "Hisob raqami 27 ta belgidan iborat bo‘lishi kerak",
            trigger: "change",
          },
        ]
      },
      ignorRules: {
        comment: [
          {required: true, message: "Majburiy maydon", trigger: "blur"},
        ],
      },
      showInitiativeFileManage: false,
      money: {
        decimal: ".",
        thousands: " ",
        prefix: "",
        suffix: "",
        precision: 0,
      },
      file: [],
      selectedInitiativeId: null,
      showSendSmsDialog: false,
      selectedBoardIdForSms: null,
      voteCheckDialogVisible: false,
      voteCheckSubmitting: false,
      voteCheckResultStatus: null,
      voteCheckResult: null,
      voteCheckEmptyMessage: "",
      voteCheckForm: {
        board_id: null,
        phone_number: "",
      },
      voteCheckRules: {
        board_id: [
          {required: true, message: "Majburiy maydon", trigger: "change"},
        ],
        phone_number: [
          {validator: voteCheckPhoneValidate, trigger: "blur"},
        ],
      },
      moderationStageStatus: {
        MODERATOR_ACCEPTED: "Moderator qabul qilgan",
        MODERATOR_DENIED: "Moderator rad etgan",
        DISTRICT_MANAGER_ACCEPTED: "Tuman mudiri qabul qilgan",
        DISTRICT_MANAGER_DENIED: "Tuman mudiri rad etgan",
      },
      locationDialogVisible: false,
      locationDialogTitle: null,
      relocatedInitiativeId: null,
      locationForm: {
        latitude: null,
        longitude: null,
        address_title: "",
      },
      settings: {
        apiKey: "4c616bd5-36f2-4c27-9e16-0eed43779920",
        lang: "uz_UZ",
        coordorder: "latlong",
        version: "2.1",
      },
      mobileMonitoringDialog: false,
      protocolUpload: false,
    };
  },
  methods: {
    getAiModerationBtnType(status) {
      if (status === 'PASS') return 'success';
      if (status === 'NEEDS_REVIEW') return 'warning';
      if (status === 'FAIL') return 'danger';
      return 'info';
    },
    getAiModerationIcon(status) {
      if (status === 'PASS') return '🟢';
      if (status === 'NEEDS_REVIEW') return '🟡';
      if (status === 'FAIL') return '🔴';
      return '⚪';
    },
    getVerdictIcon(verdict) {
      if (verdict === 'PASS') return '✓';
      if (verdict === 'NEEDS_REVIEW') return '⚠';
      if (verdict === 'FAIL') return '✖';
      return '⚪';
    },
    getAiModerationStatusTagType(status) {
      if (status === 'SUCCESS') return 'success';
      if (status === 'PENDING') return 'warning';
      if (status === 'FAILED') return 'danger';
      return 'info';
    },
    getAiModerationStatusLabel(status) {
      if (status === 'SUCCESS') return 'AI: tahlil tayyor';
      if (status === 'PENDING') return 'AI: tahlil qilinmoqda';
      if (status === 'FAILED') return 'AI: xatolik yuz berdi';
      return 'AI: tahlil qilinmagan';
    },
    getAiModerationOverallLabel(status) {
      if (status === 'PASS') return 'Barcha mezonlar bo\'yicha mos — tasdiqlash tavsiya etiladi';
      if (status === 'NEEDS_REVIEW') return 'Ko\'rib chiqish talab etiladi';
      if (status === 'FAIL') return 'Mezon(lar) buzilgan';
      if (status === 'FAILED') return 'AI tahlili xato bilan yakunlandi';
      if (status === 'PENDING') return 'Tekshirilmoqda...';
      return status;
    },
    openAiModerationModal(row) {
      this.aiModerationDialogVisible = true;
      this.aiModerationLoading = true;
      this.aiModerationData = null;
      this.currentAiModerationRow = row;
      this.clearAiModerationPolling();

      this.$http.get(`api/v1/initiatives/${row.id}/ai-moderation`)
        .then(({ data }) => {
          this.aiModerationData = data;
          this.scheduleAiModerationPoll();
        })
        .catch(error => {
          ElNotification.error({
            message: error.response?.data?.message || "AI tahlilini yuklashda xatolik yuz berdi"
          });
          this.aiModerationDialogVisible = false;
        })
        .finally(() => {
          this.aiModerationLoading = false;
        });
    },
    resendAiModeration() {
      if (!this.currentAiModerationRow?.id) return;

      this.aiModerationResending = true;
      this.$http.post(`api/v1/temp/initiatives-ai-moderation-send/${this.currentAiModerationRow.id}`)
        .then(() => {
          return this.$http.get(`api/v1/initiatives/${this.currentAiModerationRow.id}/ai-moderation?cache=off`);
        })
        .then(({ data }) => {
          this.aiModerationData = data;
          this.scheduleAiModerationPoll();
          ElNotification.success({
            message: "AI tahlili qayta yuklandi"
          });
        })
        .catch(error => {
          ElNotification.error({
            message: error.response?.data?.message || "AI tahlilini qayta yuborishda xatolik yuz berdi"
          });
        })
        .finally(() => {
          this.aiModerationResending = false;
        });
    },
    scheduleAiModerationPoll() {
      this.clearAiModerationPolling();
      if (this.aiModerationData?.ai_moderation_overall !== 'PENDING') return;
      if (!this.aiModerationDialogVisible || !this.currentAiModerationRow?.id) return;

      this.aiModerationPollTimer = setTimeout(() => {
        this.$http.get(`api/v1/initiatives/${this.currentAiModerationRow.id}/ai-moderation?cache=off`)
          .then(({ data }) => {
            this.aiModerationData = data;
          })
          .catch(() => {})
          .finally(() => {
            this.scheduleAiModerationPoll();
          });
      }, 5000);
    },
    clearAiModerationPolling() {
      if (this.aiModerationPollTimer) {
        clearTimeout(this.aiModerationPollTimer);
        this.aiModerationPollTimer = null;
      }
    },
    openDuplicateOriginal(publicId) {
      const routeData = this.$router.resolve({
         name: 'InitiativeEdit', 
         params: { id: this.aiModerationData.ai_duplicate_of_id } 
      });
      window.open(routeData.href, '_blank');
    },
    getPartnershipOptionValue(option) {
      if (option.value === "all") {
        return option.value;
      }

      return `${option.type}:${option.value}`;
    },
    getModeratorProtocol() {
      if (this.$store.state.role === "moderator") {
        const district_id = JSON.parse(localStorage.getItem("openBudget")).user
            .district_id;

        this.$http
            .get(`api/v1/districts/documents/protocol/single`, {
              params: {
                cache: "off",
                board_id: this.selectedBoardId,
                district_id: district_id,
              },
            })
            .then(() => {
              this.protocolUpload = false;
            })
            .catch((err) => {
              this.protocolUpload = err.response.status === 404;
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },
    addMobileMonitoring(initiative) {
      // this.mobileMonitoringDialog = true;
      this.$router.push({
        name: "MobileMonitoringList",
        params: {initiative: initiative},
      });
    },
    permissionSetLocation(initiativeId) {
      this.$http
          .post(`api/v1/moderators/initiatives/${initiativeId}/location`, {
            latitude: 0,
            longitude: 0,
          })
          .then(() => {
            ElNotification.success({
              message: "Manzil o'zgartirishga ruxsat berildi",
            });
            this.getInitiatives();
          })
          .catch((error) => {
            ElNotification.error({
              message: error.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onClickSubmit() {
      this.$http
          .post(
              `api/v1/moderators/initiatives/${this.relocatedInitiativeId}/location`,
              this.locationForm
          )
          .then(() => {
            ElNotification.success({
              message: "Manzi o'zgartirildi",
            });
            this.getInitiatives();
            this.locationDialogVisible = false;
          })
          .catch((error) => {
            ElNotification.error({
              message: error.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    async onClickMap(e) {
      if (e.get) {
        const clickedCoords = [e.get("coords")[0], e.get("coords")[1]];
        this.locationForm.latitude = clickedCoords[0];
        this.locationForm.longitude = clickedCoords[1];

        const geocoder = ymaps.geocode(clickedCoords);
        console.log(e.get("coords"));
        const response = await geocoder;
        const geoObject = response.geoObjects.get(0);

        const address = {
          city: geoObject.getLocalities().join(", "),
          region: geoObject.getAdministrativeAreas().join(", "),
          street: geoObject.getThoroughfare() || "",
          houseNumber: geoObject.getPremiseNumber() || "",
        };
        console.log(address);
        this.locationForm.address_title =
            address?.region +
            "  " +
            address?.city +
            "  " +
            address?.street +
            " " +
            address?.houseNumber;
      }
    },
    acceptDenyCancel() {
      this.acceptDenyDialogVisible = false;
      this.acceptDenyComment = null;
    },
    acceptInitiativeDistrictManager(initiativeId) {
      this.acceptDenyInitiativeId = initiativeId;
      this.acceptDenyUrlKey = "accept";
      this.acceptDenySaveInitiative();
    },
    denySave() {
      this.acceptDenySaveInitiative();
    },
    acceptDenySaveInitiative() {
      this.loading = true;
      this.$http
          .post(
              `api/v1/district-managers/initiatives/${this.acceptDenyInitiativeId}/${this.acceptDenyUrlKey}`,
              this.acceptDenyUrlKey === "accept"
                  ? null
                  : {
                    comment: this.acceptDenyComment,
                  }
          )
          .then(() => {
            ElNotification.success({
              message:
                  this.acceptDenyUrlKey === "accept" ? "Tadiqlandi" : "Rad etildi",
            });
            this.acceptDenyComment = null;
            this.acceptDenyDialogVisible = false;
            this.getInitiatives();
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message || this.acceptDenyUrlKey === "accept"
                      ? "Tadiqlanmadi"
                      : "Rad etilmadi",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    acceptDistrictManager(initiativeId, urlKey) {
      this.acceptDenyUrlKey = urlKey;
      this.acceptDenyInitiativeId = initiativeId;
      this.acceptDenyDialogVisible = true;
    },
    onChangeSubStage() {
      this.currentPage = 1;
      this.getInitiatives();
    },
    onClickSendSms() {
      if (this.selectedBoardIdForSms) {
        this.sendSmsToWinner();
      } else {
        ElNotification.error({
          message: "Sms yuborish uchun board tanlanmagan",
        });
      }
    },
    onClickShaffofQurilish(row) {
      if (!this.protocolUpload) {
        if (
            row.author_is_verified === true &&
            row.longitude !== null &&
            row.longitude !== 0.0 &&
            row.latitude !== null &&
            row.latitude !== 0.0
        ) {
          this.$router.push({
            name: "ChronologyMain",
            params: {
              public_id: row.public_id,
            },
            query: {
              id: row.id,
              board_id: row.board_id,
              region_id: row.region_id,
              district_id: row.district_id,
              council_decision_id: row.council_decision_id,

              granted_amount: row.granted_amount,
              desc: row.board_type === 'MY_GARDEN' ? row.description?.slice(0,255) : row.type === 'CONSTRUCTION' ? row.description?.slice(0,255) : row?.organization_title + ' (Жиҳозлаш)',
              type: row.type,
              soato: row.district_soato,
              tin: row.customer_tin,
              category: row.category_id,
              board_type: row.board_type,
            },
          });
        } else {
          ElNotification({
            title: "Diqqat!",
            message:
                "Tashabbuskor verifikatsiyadan o'tmagan yoki geolokatsiya biriktirilmagan.",
            type: "warning",
          });
        }
      } else {
        ElNotification({
          title: "Diqqat!",
          message: "Moderatsiya protokoli yuklanmagan",
          type: "warning",
        });
      }
    },
    sendSmsToWinner() {
      const formData = new FormData();
      formData.append("board_id", this.selectedBoardIdForSms);
      this.$http
          .post(`api/v1/temp/sms-winner-authors`, formData, {
            headers: {
              Authorization: this.$store.state.accessToken,
              "Content-Type": "multipart/form-data",
            },
          })
          .then(() => {
            ElNotification.success({
              message: "Sms yuborildi",
            });
            this.showSendSmsDialog = false;
            this.selectedBoardIdForSms = null;
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Sms yuborishda xatolik sodir bo'ldi!",
            });
          });
    },
    onClickCancel() {
      this.showSendSmsDialog = false;
      this.selectedBoardIdForSms = null;
    },
    sendSms() {
      this.showSendSmsDialog = true;
    },
    openVoteCheckDialog() {
      this.voteCheckDialogVisible = true;
      this.voteCheckSubmitting = false;
      this.voteCheckResultStatus = null;
      this.voteCheckResult = null;
      this.voteCheckEmptyMessage = "";
      this.voteCheckForm.board_id = this.selectedBoardId;
      this.voteCheckForm.phone_number = "";
    },
    closeVoteCheckDialog() {
      this.voteCheckDialogVisible = false;
      this.voteCheckSubmitting = false;
      this.voteCheckResultStatus = null;
      this.voteCheckResult = null;
      this.voteCheckEmptyMessage = "";
      this.voteCheckForm.board_id = this.selectedBoardId;
      this.voteCheckForm.phone_number = "";
      this.$refs.voteCheckFormRef?.clearValidate();
    },
    normalizeVoteCheckPhone(value) {
      return (value || "").replace(/\D/g, "").slice(0, 9);
    },
    formatVoteCheckPhone(value) {
      const digits = this.normalizeVoteCheckPhone(value);
      const first = digits.slice(0, 2);
      const second = digits.slice(2, 5);
      const third = digits.slice(5, 7);
      const fourth = digits.slice(7, 9);

      return [first, second, third, fourth].filter(Boolean).join(" ");
    },
    onVoteCheckPhoneInput(value) {
      this.voteCheckForm.phone_number = this.formatVoteCheckPhone(value);
    },
    getVoteCheckPhoneForApi() {
      return this.normalizeVoteCheckPhone(this.voteCheckForm.phone_number);
    },
    checkPhoneVote() {
      this.$refs.voteCheckFormRef.validate((valid) => {
        if (!valid) return;

        this.voteCheckSubmitting = true;
        this.voteCheckResultStatus = null;
        this.voteCheckResult = null;
        this.voteCheckEmptyMessage = "";

        axios
            .get("https://openbudget.uz/api/v1/votes/by-phone", {
              params: {
                board_id: this.voteCheckForm.board_id,
                phone_number: this.getVoteCheckPhoneForApi(),
              },
              headers: {
                Authorization: this.$store.state.accessToken,
              },
            })
            .then(({data}) => {
              if (data?.message) {
                this.voteCheckResultStatus = "empty";
                this.voteCheckEmptyMessage = data.message;
                return;
              }

              if (data && Object.keys(data).length > 0) {
                this.voteCheckResultStatus = "found";
                this.voteCheckResult = data;
                return;
              }

              this.voteCheckResultStatus = "empty";
            })
            .catch((error) => {
              if (error.response?.status === 400 && error.response?.data?.message) {
                this.voteCheckResultStatus = "empty";
                this.voteCheckEmptyMessage = error.response.data.message;
                return;
              }

              ElNotification.error({
                message:
                    error.response?.data?.message ||
                    "Tekshirishda xatolik sodir bo'ldi!",
              });
            })
            .finally(() => {
              this.voteCheckSubmitting = false;
            });
      });
    },
    formatVoteCheckDate(date) {
      if (!date) return "-";
      return this.$moment.utc(date).format("DD-MM-YYYY / HH:mm:ss");
    },
    formatVoteCheckResultPhone(phone) {
      const digits = (phone || "").replace(/\D/g, "").slice(-9);
      if (digits.length !== 9) return phone || "-";

      const first = digits.slice(0, 2);
      const second = digits.slice(2, 5);
      const third = digits.slice(5, 7);
      const fourth = digits.slice(7, 9);

      return `+998 ${first} ${second} ${third} ${fourth}`;
    },
    onChangeReestrFile(file) {
      this.file[0] = file;
      this.uploadReestrFile(file);
    },
    onClickReestrUploadButton(initiativeId) {
      this.selectedInitiativeId = initiativeId;
    },
    onExceed(files) {
      this.file[0] = files[0];
    },
    onErrorUpload(error) {
      if (error.status === 401) {
        this.$store.commit("signOut");
        this.$router.push({name: "Auth"});
      }
      ElNotification.error({
        message:
            JSON.parse(error?.message)?.message ||
            "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
        type: "error",
      });

      this.loading = false;
    },
    uploadReestrFile(file) {
      this.loading = true;
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("initiative_id", this.selectedInitiativeId);
      axios
          .post(
              `${process.env.VUE_APP_BASE_API_URL}api/v1/initiatives-excel-products`,
              formData,
              {
                headers: {
                  Authorization: this.$store.state.accessToken,
                },
              }
          )
          .then(() => {
            ElNotification.success({
              message: "Fayl yuklandi",
            });
          })
          .catch((error) => {
            ElNotification.error({
              message:
                  error.response.data.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // Mavsum bosqichi + tashabbus bosqichi + rol — bu qoida muddat bayrog'idan
    // oldin ham bor edi va o'zgarmaydi. Bayroq faqat "berish" yo'nalishiga
    // qo'shimcha shart (qarang: canGrantEditPermission).
    authorEditControlVisible(row) {
      const stage = this.selectedBoard?.stage;
      return (
          (stage === "REVIEW" || stage === "PROMOTION") &&
          row.stage === "INITIAL" &&
          this.$store.state.role === "moderator"
      );
    },
    onClickAuthorEdit(initiativeId, isEditable) {
      this.loading = true;
      this.$http
          .post(`api/v1/moderators/editable/initiatives/${initiativeId}`, {
            is_editable: isEditable,
          })
          .then(() => {
            ElNotification.success({
              message: isEditable
                  ? "Muallifga tahrirlash huquqi berildi"
                  : "Muallifdan tahrirlash huquqi olindi",
            });
            this.getInitiatives();
          })
          .catch((error) => {
            const data = error?.response?.data;
            // 403 = muddat tugagan. Mavsumlar ro'yxati serverda 5 daqiqa
            // keshlanadi, shuning uchun boardni qayta so'rasak eskirgan `true`
            // qaytishi mumkin — server javobi yakuniy, bayroqni mahalliy yopamiz
            // va faqat tashabbuslar ro'yxatini yangilaymiz.
            if (error?.response?.status === 403 && this.selectedBoard) {
              this.selectedBoard.can_grant_edit_permission = false;
              this.getInitiatives();
            } else {
              this.loading = false;
            }
            ElNotification.error({
              message:
                  data?.message ||
                  "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
            });
          });
    },
    toggleInitiativeFileManage() {
      this.showInitiativeFileManage = !this.showInitiativeFileManage;
    },
    returnInitiative(public_id) {
      ElMessageBox.confirm(
          "Tashabbus bosqichini dastlabki holatga qaytarasizmi??",
          "Warning",
          {
            confirmButtonText: "Ha",
            cancelButtonText: "Bekor qilish",
            type: "warning",
          }
      ).then(() => {
        this.loading = true;
        this.$http
            .patch(`api/v1/initiatives/${public_id}`, {
              stage: "INITIAL",
              granted_amount: 0,
              moderator_comment: "",
            })
            .then(() => {
              ElNotification.success({
                message: "Tashabbus dastlabki bosqichga qaytarildi.",
              });
              this.getInitiatives();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
      });
    },

    promoteToWinner(public_id) {
      ElMessageBox.confirm(
          "Tashabbusni chindan ham golib etib tayinlaysizmi ??",
          "Warning",
          {
            confirmButtonText: "Ha",
            cancelButtonText: "Bekor qilish",
            type: "warning",
          }
      ).then(() => {
        this.loading = true;
        this.$http
            .patch(`api/v1/initiatives/${public_id}`, {
              stage: "WINNER",
            })
            .then(() => {
              ElNotification.success({
                message: "Tashabbus golib deb tayinlandi.",
              });
              this.getInitiatives();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
      });
    },

    returnToPassedStage(public_id) {
      ElMessageBox.confirm(
          "Tashabbusni chindan ham goliblikdan mahrum etasizmi ??",
          "Warning",
          {
            confirmButtonText: "Ha",
            cancelButtonText: "Bekor qilish",
            type: "warning",
          }
      ).then(() => {
        this.loading = true;
        this.$http
            .patch(`api/v1/initiatives/${public_id}`, {
              stage: "PASSED",
            })
            .then(() => {
              ElNotification.success({
                message: "Tashabbus goliblikdan mahrum etildi.",
              });
              this.getInitiatives();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
      });
    },
    investIdDialog(public_id) {
      this.investId = !this.investId;
      this.currentPublicId = public_id;
    },

    toggleIgnoreInitiativeDialog(public_id) {
      this.dialogIgnoreInitiative = !this.dialogIgnoreInitiative;
      this.currentPublicId = public_id;
      this.ignoreForm.comment = null;
      this.ignoreForm.ignoreInitiativeFileId = null;
    },
    handleRemoveFile() {
      this.declineForm.file_id = null;
    },
    handleRemoveFile_IgnoreInitiative() {
      this.ignoreForm.ignoreInitiativeFileId = null;
    },
    onSuccessFileUpload(res) {
      this.declineForm.file_id = res.hashId;
    },
    onSuccessFileUpload_IgnoreInitiative(res) {
      this.ignoreForm.ignoreInitiativeFileId = res.hashId;
    },
    onChangeBoard() {
      this.currentPage = 1;
      this.$router.replace({
        query: {...this.$route.query, page: 1, board: this.selectedBoardId},
      });
      this.getInitiatives();
      this.getModeratorProtocol();
    },
    onChangePartnership() {
      this.currentPage = 1;

      this.$router.replace({
        query: {
          ...this.$route.query,
          page: 1,
          ...this.partnershipQueryForRoute,
        },
      });
      this.getInitiatives();
      this.getModeratorProtocol();
    },
    checkDate() {
      const board = this.boards.find(
          (item) => item.id === this.selectedBoardId
      );
      const startDate = new Date(board.review_start_date).valueOf();
      const endDate = new Date(board.review_end_date).valueOf();
      const now = new Date().valueOf();
      this.disableButtons = !(startDate <= now && now <= endDate);
    },
    onSearch() {
      this.currentPage = 1;
      this.$router.replace({query: {...this.$route.query, page: 1}});
      this.getInitiatives();
    },
    indexMethod(index) {
      return index + (this.currentPage - 1) * this.limit + 1;
    },
    handleCurrentChange() {
      this.$router.replace({
        query: {...this.$route.query, page: this.currentPage},
      });
      this.getInitiatives();
    },
    handleSizeChange() {
      this.$router.replace({
        query: {...this.$route.query, size: this.limit, page: 1},
      });
      this.currentPage = 1;
      this.getInitiatives();
    },
    updateAktFile(publicId) {
      this.$http
          .put(`api/v1/chronology/update-deed`, {public_id: publicId})
          .then(() => {
            ElNotification({
              message: "AKT fayli yangilandi!",
              type: "success",
            });
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message || "Yangilashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          });
    },
    downloadFile() {
      this.loading = true;
      this.$http
          .get(`api/v1/initiatives-excel`, {
            responseType: "blob",
            params: {
              board_id: this.selectedBoardId,
              stage: this.stage,
            },
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onChangeStage() {
      this.$router.replace({
        query: {...this.$route.query, stage: this.stage},
      });
      this.getInitiatives();
    },
    closeInvestId() {
      this.investId = false;
    },
    closeDecline() {
      this.declineDialog = false;
      this.declineFiles = [];
      this.declineForm = {
        id: null,
        cancelation_reason_id: null,
        moderator_comment: null,
        file_id: null,
      };
    },
    closeIgnoreInitiative() {
      this.dialogIgnoreInitiative = false;
      this.ignoredInitiativeFiles = [];
      this.ignoreForm.ignoreInitiativeFileId = null;
      this.currentPublicId = null;
    },
    completeIgnoreInitiative() {
      this.$refs.ignoreForm.validate((valid) => {
        if (this.currentPublicId && valid) {
          this.loading = true;
          this.$http
              .post(`api/v1/initiatives/${this.currentPublicId}/ignore`, {
                ignored_file_id: this.ignoreForm.ignoreInitiativeFileId,
                comment: this.ignoreForm.comment,
              })
              .then(() => {
                ElNotification.success({
                  message: "Tashabbus goliblikdan mahrum etildi.",
                });
                this.closeIgnoreInitiative();
                this.getInitiatives();
              })
              .catch((error) => {
                console.log(error);
                ElNotification.error({
                  message:
                      error.response.data.message ||
                      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },
    completeInvestId() {
      if (this.invest_object_id) {
        this.loading = true;
        this.$http
            .post(`api/v1/chronology`, {
              public_id: this.currentPublicId,
              invest_object_id: this.invest_object_id,
            })
            .then(() => {
              ElNotification.success({
                message: "Invest Id biriktirildi!",
              });
              this.closeInvestId();
              this.getInitiatives();
            })
            .catch((error) => {
              console.log(error);
              ElNotification.error({
                message:
                    error.response.data.message ||
                    "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
              });
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },
    completeDecline() {
      this.$refs.declineForm.validate((valid) => {
        if (valid) {
          this.loading = true;

          let url;

          if (this.$store.state.role === "my_garden_moderator") {
            url = `api/v1/my-garden-moderators/decline/initiatives/${this.declineForm.id}`;
          } else {
            url = `api/v1/moderators/decline/initiatives/${this.declineForm.id}`;
          }
          this.$http
              .post(url, this.declineForm)
              .then(() => {
                ElNotification.success({
                  message: "Rad etish amalga oshirildi!",
                });
                this.closeDecline();
                this.getInitiatives();
              })
              .catch((error) => {
                console.log(error);
                ElNotification.error({
                  message:
                      error.response.data.message ||
                      "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }
      });
    },

    acceptInitiative(initiative) {
      this.$router.push({
        name: "AcceptInitiative",
        params: { id: initiative?.id, boardId: this.selectedBoardId }
      });

    },
    bringToModiration(row){
      const status = row?.ai_moderation_status;

      if (status === 'SUCCESS' || status === 'FAILED') {
        this.openAiModerationModal(row);
        return;
      }

      if (status === 'PENDING') {
        ElNotification({
          type: 'info',
          title: 'AI tahlili jarayonda',
          message: "Ushbu tashabbus uchun AI tahlili hali yakunlanmagan. Iltimos, birozdan so'ng qayta urinib ko'ring.",
        });
        return;
      }

      if (!status && this.$store.state.role === 'admin') {
        ElMessageBox.confirm(
            "Moderatsiyaga jo'natishni xoxlaysizmi ?",
            "Warning",
            {
              confirmButtonText: "Ha",
              cancelButtonText: "Bekor qilish",
              type: "warning",
            }
        ).then(() => {
          this.loading = true;
          this.$http.post(`api/v1/temp/initiatives-ai-moderation-send/${row.id}`)
              .then(() => {
                ElNotification.success({
                  message: "Tashabbus moderatsiyaga jo'natildi",
                });
                this.getInitiatives();
              })
              .catch((error) => {
                ElNotification.error({
                  message: error.response?.data?.message || "Amaliyotni bajarishda xatolik sodir bo'ldi. Iltimos qayta urinib ko'ring!",
                });
              })
              .finally(() => {
                this.loading = false;
              });
        }).catch(() => {});
        return;
      }

      ElNotification({
        type: 'warning',
        title: 'AI tahlili mavjud emas',
        message: "Ushbu tashabbus uchun AI tahlili hali amalga oshirilmagan. Iltimos Admin larga murojat qiling",
      });
    },
    declineInitiative(id) {
      this.declineDialog = true;
      this.declineForm.id = id;
    },
    generateSrcList(imgList) {
      return imgList.map(
          (image) => `${this.BASE_IMAGE_URL}${image}?type=LARGE`
      );
    },
    getInitiatives() {
      this.loading = true;
      this.$http
          .get(`api/v1/moderators/initiatives`, {
            params: {
              stage: this.stage,
              limit: this.limit,
              offset: this.limit * (this.currentPage - 1),
              search: this.search,
              board_id: this.selectedBoardId,
              moderation_sub_stage: this.moderation_sub_stage,
              is_partnership: this.partnershipParamsForApi.is_partnership,
              is_deputy_chosen: this.partnershipParamsForApi.is_deputy_chosen
            },
          })
          .then(({data}) => {
            this.initiatives = data.initiatives;
            this.totalCount = data.count;
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
    },
    getCancelingReasons() {
      this.$http
          .get(`api/v1/initiatives/cancelation-reasons`)
          .then(({data}) => {
            this.cancelingReasons = data.cancelation_reasons;
          })
          .catch((err) => {
            console.error("cancel reason fetch error", err);
          });
    },
    getCategories() {
      this.$http
          .get(`api/v1/initiative-categories`)
          .then(({data}) => {
            this.categories = data.initiative_categories;
          })
          .catch((err) => {
            console.error("category fetch error", err);
          });
    },
    getBoards() {
      this.loading = true;
      this.$http
          .get(`api/v1/boards`, {
            params: {
              status: 1,
              type:
                  this.$store.state.role === "my_garden_moderator"
                      ? "MY_GARDEN"
                      : null,
            },
          })
          .then(({data}) => {
            this.boards = data.boards;
            if (this.$route.query.board) {
              this.selectedBoardId = parseInt(this.$route.query.board);
            } else {
              this.selectedBoardId = data.boards[0].id;
            }
            this.getInitiatives();
            this.checkDate();
            this.getModeratorProtocol();
          })
          .catch((err) => {
            console.error("boards fetch error", err);
            this.loading = false;
          });
    },
    showOnMap(lat, long, title) {
      this.latLong = [lat, long];
      this.showMapDialog = true;
      this.dialogTitle = title;
    },
    changeLocation(id, lat, long, title) {
      this.relocatedInitiativeId = id;
      this.locationDialogTitle = title;
      this.locationForm.latitude = lat;
      this.locationForm.longitude = long;
      this.locationDialogVisible = true;
    },
    downloadVotes() {
      this.downloadVoteExcel();
    },

    downloadVoteExcel() {
      this.loading = true;
      this.$http
          .get(`api/v1/votes/excel`, {
            responseType: "blob",
            params: {
              board_id: this.selectedBoardId,
            },
          })
          .then((res) => {
            const url = URL.createObjectURL(
                new Blob([res.data], {
                  type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                })
            );
            const header = res.headers.get("Content-Disposition");
            const parts = header.split(";");
            let fileName = parts[1].split("=")[1];
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          })
          .catch(({response}) => {
            ElNotification({
              title: "Ogohlantirish",
              message:
                  response.data.message ||
                  "Ma'lumot yuklashda xatolik sodir bo'ldi!",
              type: "warning",
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    // getInitiativeById(initiative) {
    //   this.loading = true;
    //   this.$http
    //       .get(`api/v1/initiatives/${initiative.id}`)
    //       .then(({data}) => {
    //         if (initiative.organization_id) {
    //           this.getOrganizations(initiative.district_id, this.acceptForm.category_id);
    //         }
    //         this.getQuarters(initiative.district_id);
    //         // this.getTags();
    //       })
    //       .catch((err) => {
    //         console.error("quarters fetch error", err);
    //       })
    //       .finally(() => {
    //         this.loading = false
    //       });
    // },

    // Transit account
    closeTransitDialog() {
      this.isShowTransit = false;
    },
    showTransitDialog(id, account_number) {
      console.log(id)
      this.transitForm.transit_account_number = account_number
      this.initiativeId = id
      this.isShowTransit = true;
    },
    allowTransitChange(initiativeId) {
      this.loading = true;

      this.$http
          .post(`api/v1/moderators/initiatives/${initiativeId}/transit-account`)
          .then(() => {
            ElNotification.success({
              message: "Tranzit raqamini o'zgartirishga ruxsat berildi",
            });
            this.getInitiatives();
          })
          .catch((error) => {
            ElNotification.error({
              message: error.response.data.message,
            });
          })
          .finally(() => {
            this.loading = false;
          });
    },
    transitNumberCreate() {
      this.$refs.transitForm.validate((valid) => {
        if (!valid) return

        this.loading = true;

        this.$http
            .post(`api/v1/moderators/initiatives/${this.initiativeId}/transit-account`, this.transitForm)
            .then(() => {
              ElNotification.success({
                message: "Tranzit raqam biriktirildi",
              });
              this.getInitiatives();
            })
            .catch((error) => {
              ElNotification.error({
                message: error.response.data.message,
              });
            })
            .finally(() => {
              this.loading = false;
              this.closeTransitDialog()
            });
      })
    },
  },

  beforeUnmount() {
    this.clearAiModerationPolling();
  },

  mounted() {
    if (this.$route.query.stage) {
      this.stage = this.$route.query.stage;
    }
    if (this.$route.query.size) {
      this.limit = parseInt(this.$route.query.size);
    }
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page);
    }
    if (this.$route.query.is_deputy_chosen) {
      this.selectedPartnership = "is_deputy_chosen:true";
    } else if (this.$route.query.is_partnership) {
      this.selectedPartnership = "is_partnership:true";
    }
    if (this.$store.state.role === "district_manager") {
      this.moderation_sub_stage = "MODERATOR_ACCEPTED";
    }
    this.$nextTick(() => {
      this.getBoards();
    });
    this.getCancelingReasons();
    this.getCategories();
  },
};
</script>

<style scoped>
.ai-overall-banner {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 8px;
  margin-bottom: 15px;
  font-size: 15px;
  font-weight: 600;
}
.ai-overall-banner-icon {
  font-size: 20px;
  line-height: 1;
}
.ai-overall-banner--pass {
  background: #f0f9eb;
  color: #529b2e;
  border: 1px solid #e1f3d8;
}
.ai-overall-banner--needs_review {
  background: #fdf6ec;
  color: #b88230;
  border: 1px solid #faecd8;
}
.ai-overall-banner--fail {
  background: #fef0f0;
  color: #c45656;
  border: 1px solid #fde2e2;
}
.ai-overall-banner--failed {
  background: #f4f4f5;
  color: #909399;
  border: 1px solid #e9e9eb;
}
.ai-overall-banner--pending {
  background: #f4f4f5;
  color: #909399;
  border: 1px solid #e9e9eb;
}
.ai-pending-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid #dcdfe6;
  border-top-color: #909399;
  border-radius: 50%;
  animation: ai-pending-spin 0.8s linear infinite;
}
@keyframes ai-pending-spin {
  to {
    transform: rotate(360deg);
  }
}
.ai-criterion-row {
  display: flex;
  margin-bottom: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #eef0f3;
}
.ai-criterion-icon {
  font-size: 18px;
  font-weight: bold;
  margin-right: 12px;
  margin-top: -2px;
}
.ai-criterion-details {
  flex: 1;
}
.ai-criterion-title {
  font-weight: 600;
  font-size: 14px;
  color: #303133;
  margin-bottom: 4px;
}
.ai-criterion-message {
  font-size: 13px;
  color: #606266;
  line-height: 1.4;
}

.header-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 10px;
}

.header {
  display: inline-flex;
  min-width: max-content;
  justify-content: space-between;
}

.initiative-title,
:deep(.el-dialog__header) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.desc-item {
  margin: 10px;
}

/* Disabled tugma tooltip eventlarini yutadi — shuning uchun wrapper span. */
.edit-permission-locked {
  display: inline-flex;
  align-items: center;
  margin-left: 12px;
  cursor: not-allowed;
}

.edit-permission-locked + .el-button {
  margin-left: 12px;
}

.edit-permission-locked :deep(.el-button.is-disabled) {
  pointer-events: none;
  border-style: dashed;
}

.field-title {
  color: #0f152d;
  font-weight: bold;
  margin-right: 5px;
}

.image-list {
  display: flex;
  gap: 10px;
}

:deep(.el-table .el-table__cell) {
  z-index: unset !important;
}

.pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
  margin-top: 10px;
}

:deep(.el-upload-list__item) {
  max-width: 250px;
}

.applications {
  text-align: center;
}

.vote-check-alert {
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 8px;
  line-height: 1.6;
}

.vote-check-alert.success {
  background: #f0f9eb;
  border: 1px solid #c2e7b0;
}

.vote-check-alert.warning {
  background: #fdf6ec;
  border: 1px solid #f3d19e;
}

.vote-check-title {
  font-weight: 700;
}

.success-text {
  color: #67c23a;
}

.warning-text {
  color: #e6a23c;
}
</style>
